import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5612e852"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oc"
}
const _hoisted_2 = { class: "grey" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "shop_name" }
const _hoisted_6 = {
  key: 0,
  class: "is_wulian"
}
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = {
  key: 0,
  class: "abnormal"
}
const _hoisted_10 = {
  key: 1,
  class: "abstract"
}
const _hoisted_11 = {
  key: 2,
  class: "img"
}
const _hoisted_12 = { class: "footer" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "grey" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "shop_name" }
const _hoisted_19 = {
  key: 0,
  class: "is_wulian"
}
const _hoisted_20 = { class: "detail" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "content_item" }
const _hoisted_23 = { class: "content_item" }
const _hoisted_24 = { class: "content_item" }
const _hoisted_25 = { class: "footer" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_reject_delay_apply = _resolveComponent("reject-delay-apply")!
  const _component_reject_open_shop_apply = _resolveComponent("reject-open-shop-apply")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_van_tabs, {
            active: $setup.active,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
            sticky: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_tab, { title: "开闭店审批" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.ocList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item",
                        key: item.id,
                        onClick: ($event: any) => (
              _ctx.$router.push({
                name: _ctx.$RouterName.OPEN_CLOSE_SHOP_APPLY_DETAILS,
                query: {
                  id: item.id
                }
              })
            )
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(item.stores_name) + _toDisplayString(item.oc_type_name), 1),
                          (item.is_wulian === '1')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "物联"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_7, [
                            _createTextVNode("详情"),
                            _createVNode(_component_van_icon, { name: "arrow" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          (item.desc_error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.desc_error), 1))
                            : _createCommentVNode("", true),
                          (item.desc)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "摘要：" + _toDisplayString(item.desc), 1))
                            : _createCommentVNode("", true),
                          (item.desc_pics_arr.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.desc_pics_arr, (pic) => {
                                  return (_openBlock(), _createBlock(_component_van_image, {
                                    key: pic.id,
                                    width: "60",
                                    height: "60",
                                    src: pic.photo_thumb_file
                                  }, null, 8, ["src"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (item.opt_lists.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_van_divider, {
                                dashed: "",
                                style: { color: '#CCD3DF', borderColor: '#CCD3DF' }
                              }),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", {
                                  class: "btn reject",
                                  onClick: _withModifiers(($event: any) => ($setup.optClick(item, '3')), ["stop"])
                                }, "驳回", 8, _hoisted_13),
                                _createElementVNode("div", {
                                  class: "btn agree",
                                  onClick: _withModifiers(($event: any) => ($setup.optClick(item, '2')), ["stop"])
                                }, "通过", 8, _hoisted_14)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_3))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_tab, { title: "延期申请" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.delayLists, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item",
                        key: item.id,
                        onClick: ($event: any) => (
              _ctx.$router.push({
                name: _ctx.$RouterName.DELAY_APPLY_DETAILS,
                query: {
                  id: item.id
                }
              })
            )
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(item.stores_name) + _toDisplayString(item.oc_type_name), 1),
                          (item.is_wulian === '1')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, "物联"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_20, [
                            _createTextVNode("详情"),
                            _createVNode(_component_van_icon, { name: "arrow" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, "申请延期至：" + _toDisplayString(item.date_end), 1),
                          _createElementVNode("div", _hoisted_23, "延期原因：" + _toDisplayString(item.delay_reason_name), 1),
                          _createElementVNode("div", _hoisted_24, "备注：" + _toDisplayString(item.desc), 1)
                        ]),
                        (item.opt_lists.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_van_divider, {
                                dashed: "",
                                style: { color: '#CCD3DF', borderColor: '#CCD3DF', margin: '12px 0px' }
                              }),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", {
                                  class: "btn reject",
                                  onClick: _withModifiers(($event: any) => ($setup.optClick(item, '6')), ["stop"])
                                }, "驳回", 8, _hoisted_26),
                                _createElementVNode("div", {
                                  class: "btn agree",
                                  onClick: _withModifiers(($event: any) => ($setup.optClick(item, '5')), ["stop"])
                                }, "同意", 8, _hoisted_27)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_16))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["active"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_reject_delay_apply, {
      show: $setup.rejectDelayApplyInfo.show,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.rejectDelayApplyInfo.show) = $event)),
      onSubmit: $setup.rejectDelayApplyInfo.onSubmit
    }, null, 8, ["show", "onSubmit"]),
    _createVNode(_component_reject_open_shop_apply, {
      show: $setup.rejectOpenShopApplyInfo.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.rejectOpenShopApplyInfo.show) = $event)),
      option: $setup.rejectOpenShopApplyInfo.option,
      onSubmit: $setup.rejectOpenShopApplyInfo.onSubmit
    }, null, 8, ["show", "option", "onSubmit"])
  ], 64))
}